module.exports = __webpack_public_path__ + "img/page-30.1d0ec577.jpg";